export const UserType = {
  // ADMIN: 1,
  BUYER: 2,
  SELLER: 3
};